import React, {Component} from 'react';
import PropTypes from 'prop-types';
import NavigationContainer from '../../components/navigation-container';
import {convertPipeToBrTag} from "../../utils";
import {WINDOW, DOCUMENT} from '../../constants/environment'

/**
 * SubNavigationPc
 */

class SubNavigationPc extends Component {
  static propTypes = {
    pcTitle: PropTypes.string,
    mbTitle: PropTypes.string,
    carsTitle: PropTypes.bool,
    rootLink: PropTypes.shape({
      pageName: PropTypes.string,
      pcText: PropTypes.string,
      mbText: PropTypes.string,
      href: PropTypes.string,
      external: PropTypes.bool,
    }),
    estimationHistory: PropTypes.arrayOf(PropTypes.node),
    links: PropTypes.arrayOf(PropTypes.shape({
      pageName: PropTypes.string,
      pcText: PropTypes.string,
      mbText: PropTypes.string,
      href: PropTypes.string,
      external: PropTypes.bool,
      nestedNavigation: PropTypes.object,
    })),
    hierarchy: PropTypes.number,
    subNavigation: PropTypes.object,
    deleteRootPageLink: PropTypes.bool,
  };
  static defaultProps = {
    pcTitle: null,
    mbTitle: null,
    carsTitle: null,
    rootLink: null,
    estimationHistory: null,
    links: null,
    hierarchy: null,
    subNavigation: null,
    deleteRootPageLink: false,
  };

  constructor(props) {
    super();
    this.props = props;
    this.state = {
      estimationHistoryOpen: false,
    };
  }

  componentDidMount() {
    this.setEstimateCount();
    WINDOW.addEventListener('resize', this.onResize);
    WINDOW.addEventListener('scroll', this.onScroll);
    this.triggerEvent(WINDOW, 'scroll');
  }

  componentWillUnmount() {
    WINDOW.removeEventListener('resize', this.onResize);
    WINDOW.removeEventListener('scroll', this.onScroll);
  }

  onResize = (e) => {
    this.fit();
  };

  onScroll = (e) => {
    this.fit();
  };

  fit = () => {
    const scrollTop = DOCUMENT.documentElement.scrollTop || DOCUMENT.body.scrollTop;
    const subNavigation = DOCUMENT.querySelector('.SubNavigation');

    let subNavigationHeight = subNavigation.clientHeight;
    let headerHeight = 0;

    if (subNavigation.classList.contains('fixed')) {
      headerHeight = 0;
    }
    else {
      if (DOCUMENT.querySelector('.Header') && DOCUMENT.querySelector('.Header').clientHeight) {
        headerHeight = DOCUMENT.querySelector('.Header').clientHeight - scrollTop;
      }
    }

    const estimationHistory = this.refs.estimationHistory;

    if (estimationHistory && this.validEstimateJson()) {
      //
      let height = WINDOW.innerHeight - headerHeight - subNavigationHeight;

      // EPIServerのプレビュー時のモーダルの位置調整
      if (WINDOW && WINDOW.epi && WINDOW.parent) {
        const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
        if (wrapperElement) {
          height = wrapperElement.clientHeight;
        }
      }

      //
      estimationHistory.style.height = height + 'px';
      //
      const no_ests = estimationHistory.querySelector('.EstimationHistory__container__no-ests');
      if (no_ests) {
        no_ests.style.height = (height - 25) + 'px';
      }
      //
      let est = {};
      if (WINDOW && WINDOW.localStorage && WINDOW.localStorage.getItem) {
        const json = WINDOW.localStorage.getItem('mj_est');
        est = JSON.parse(json);
      }
      if(no_ests &&
        est && Object.keys(est).length > 0 &&
        (('saved' in est && Array.isArray(est['saved']) && est['saved'].length > 0) || ('unsaved' in est && Array.isArray(est['unsaved']) && est['unsaved'].length > 0))
      ) {
        no_ests.style.height = '';
      }
    }

  };

  onClickEstimationHistory = (e) => {
    this.setState({
      estimationHistoryOpen: !this.state.estimationHistoryOpen,
    });
  };

  validEstimateJson = () => {
    if (WINDOW && WINDOW.localStorage && WINDOW.localStorage.getItem) {
      const json = WINDOW.localStorage.getItem('mj_est');
      try{
        JSON.parse(json);
        return true;
      }
      catch (e) {
        return false;
      }
    }
    else{
      return false;
    }
  };

  triggerEvent = (element, event) => {
    if (document.createEvent) {
      // IE以外
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent(event, true, true); // event type, bubbling, cancelable
      return element.dispatchEvent(evt);
    } else {
      // IE
      var evt = document.createEventObject();
      return element.fireEvent("on" + event, evt)
    }
  };

  getPcHeading = () => {
    if (this.props.pcTitle !== null) {
      return this.props.pcTitle
    } else {
      if (this.props.rootLink !== null) {
        if (this.props.rootLink.pcText !== null) {
          return this.props.rootLink.pcText
        } else if (this.props.rootLink.pageName !== null) {
          return this.props.rootLink.pageName
        }
      }
    }
    return null
  };

  getMbHeading = () => {
    if (this.props.mbTitle !== null) {
      return this.props.mbTitle
    } else if (this.props.pcTitle !== null) {
      return this.props.pcTitle
    } else {
      if (this.props.rootLink !== null) {
        if (this.props.rootLink.mbText !== null) {
          return this.props.rootLink.mbText
        } else if (this.props.rootLink.pcText !== null) {
          return this.props.rootLink.pcText
        } else if (this.props.rootLink.pageName !== null) {
          return this.props.rootLink.pageName
        }
      }
    }
    return null
  };

  setEstimateCount = () => {
    let cnt = 0;
    let est = {};

    if(!this.validEstimateJson()){
      return false;
    }

    if (WINDOW && WINDOW.localStorage && WINDOW.localStorage.getItem) {
      const json = WINDOW.localStorage.getItem('mj_est');
      est = JSON.parse(json);
    }
    if (est && Object.keys(est).length > 0 && 'unsaved' in est && Array.isArray(est['unsaved']) && est['unsaved'].length > 0) {
      cnt += est['unsaved'].length;
    }
    if (est && Object.keys(est).length > 0 && 'saved' in est && Array.isArray(est['saved']) && est['saved'].length > 0) {
      cnt += est['saved'].length;
    }

    const estimationCount = this.refs.estimationCount;
    if (estimationCount) {
      estimationCount.classList.add('n' + cnt);
    }

  };

  render() {
    const {
      pcTitle,
      mbTitle,
      carsTitle,
      rootLink,
      estimationHistory,
      links,
      hierarchy,
      subNavigation,
      deleteRootPageLink
    } = this.props;

    return (
      <div className="SubNavigation__pc">
        <div className="SubNavigation__container2">
          <div className="SubNavigation__layout">
            <div className="SubNavigation__layout-left">
              {(() => {
                // 第1階層タイトル
                if (rootLink !== null && rootLink.href !== null) {
                  if (deleteRootPageLink) {
                    return (
                      <div className={'SubNavigation__heading' + ((carsTitle === true) ? ' carsTitle': '') + ((hierarchy <= 1) ? ' current': '')}>
                        <div className="SubNavigation__heading-link">
                          <h3 className="SubNavigation__heading-pc">
                            <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(this.getPcHeading())}}/>
                          </h3>
                          <h3 className="SubNavigation__heading-mb">
                            <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(this.getMbHeading())}}/>
                          </h3>
                        </div>
                      </div>
                    )
                  } else {
                    return (
                      <div className={'SubNavigation__heading' + ((carsTitle === true) ? ' carsTitle': '') + ((hierarchy <= 1) ? ' current': '')}>
                        <a className="SubNavigation__heading-link" href={rootLink.href}
                           target={(rootLink.external === true) ? '_blank': ''}>
                          <h3 className="SubNavigation__heading-pc">
                            <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(this.getPcHeading())}}/>
                          </h3>
                          <h3 className="SubNavigation__heading-mb">
                            <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(this.getMbHeading())}}/>
                          </h3>
                        </a>
                      </div>
                    )
                  }
                } else {
                  return (
                    <div className={'SubNavigation__heading' + ((carsTitle === true) ? ' carsTitle': '')}>
                      <h3 className="SubNavigation__heading-pc">
                        <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(this.getPcHeading())}}/>
                      </h3>
                      <h3 className="SubNavigation__heading-mb">
                        <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(this.getMbHeading())}}/>
                      </h3>
                    </div>
                  )
                }
              })()}
            </div>
            {(() => {
              // 第2階層リンク
              if (links !== null && 1 <= links.length) {
                let end = false;
                if (hierarchy === 2) end = true;
                return (
                  <div className="SubNavigation__layout-center">
                    <SubNavigationItem
                      topLink={null}
                      links={links}
                      excludedWidth={400}
                      end={end}
                    />
                  </div>
                )
              } else {
                return null
              }
            })()}
            <div className="SubNavigation__layout-right">
              {(() => {
                if (estimationHistory != null && estimationHistory.length > 0 && this.validEstimateJson()) {
                  let text = estimationHistory[0] && estimationHistory[0].props && estimationHistory[0].props.navigationTitle && estimationHistory[0].props.navigationTitle !== '' ? estimationHistory[0].props.navigationTitle: '';
                  let icon = estimationHistory[0] && estimationHistory[0].props && estimationHistory[0].props.navigationIcon && estimationHistory[0].props.navigationIcon !== '' ? estimationHistory[0].props.navigationIcon: '';
                  return (
                    <div className="SubNavigation__estimation-history__button">
                      <a href='javascript:void(0)' className="SubNavigation__estimation-history__button__link"
                         onClick={this.onClickEstimationHistory}>
                        <span className="SubNavigation__estimation-history__button__link__label">{text}</span>
                        <span className="SubNavigation__estimation-history__button__link__icon-container">
                          <img className="SubNavigation__estimation-history__button__link__icon" src={icon}/>
                          <span className="SubNavigation__estimation-history__button__link__count"
                                ref='estimationCount'></span>
                        </span>
                      </a>
                    </div>
                  )
                }
              })()}
            </div>
          </div>
          {(() => {
            if (links !== null && 1 <= links.length) {
              return (
                links.map((link, index) => {
                  // 第3階層リンク
                  if (link.current === true && link.nestedNavigation !== null) {
                    let end = false;
                    if (hierarchy === 3) end = true;
                    return (
                      <div className="SubNavigation__layout2" key={index}>
                        <SubNavigationItem
                          topLink={link.nestedNavigation.topLink}
                          links={link.nestedNavigation.links}
                          excludedWidth={0}
                          end={end}
                        />
                      </div>
                    )
                  } else {
                    return null
                  }
                })
              )
            } else {
              return null
            }
          })()}
        </div>
        {(() => {
          if (estimationHistory != null && estimationHistory.length > 0 && this.validEstimateJson()) {
            return (
              <div
                className={
                  "SubNavigation__estimation-history" +
                  (this.state.estimationHistoryOpen === true ? ' open': '')
                }
                ref='estimationHistory'
              >
                <div className="SubNavigation__estimation-history__inner">
                  {estimationHistory}
                </div>
                <div className="SubNavigation__estimation-history__close">
                  <a href='javascript:void(0)' onClick={this.onClickEstimationHistory}
                     className="SubNavigation__estimation-history__close__button">close</a>
                </div>
              </div>
            )
          }
        })()}
      </div>
    )
  }
}

export default SubNavigationPc;

/**
 * SubNavigationItem
 */
class SubNavigationItem extends Component {
  static propTypes = {
    topLink: PropTypes.object,
    links: PropTypes.array,
    excludedWidth: PropTypes.number,
    end: PropTypes.bool,
  };
  static defaultProps = {
    topLink: null,
    links: null,
    excludedWidth: 0,
    end: false,
  };

  constructor(props) {
    super();
    this.props = props;
    this.items = [];
    this.state = {
      isMounted: false,
    }
  }

  componentDidMount() {
    this.setState({
      isMounted: true,
    });
  };

  componentWillUnmount() {
    this.setState({
      isMounted: false,
    });
  }

  render() {
    this.items = [];
    return (
      <div className="SubNavigation__item">
        {(() => {
          if (this.props.links !== null) {
            return (
              <NavigationContainer
                getItemPositions={this.getItemPositions}
                getCurrentItemPosition={this.getCurrentItemPosition}
                excludedWidth={this.props.excludedWidth}
              >
                <ul className="SubNavigation__list-ul">
                  {(() => {
                    if (this.props.topLink !== null && this.props.topLink.display === true) {
                      // TOPリンク
                      this.items.push('itemTop');
                      if (this.state.isMounted) {

                        // 下層にcurrentがある場合はTOPリンクはcurrentにしない
                        let current = (this.props.topLink.href === location.pathname) ? true: this.props.topLink.current;
                        let i, max;
                        for (i = 0, max = this.props.links.length; i < max; i = i + 1) {
                          if (this.props.links[i].current === true) {
                            current = false;
                            break;
                          }
                        }

                        return (
                          <li ref={'itemTop'} data-current="">
                            <SubNavigationLink
                              pageName={(this.props.topLink.pageName) ? this.props.topLink.pageName + ' TOP': null}
                              pcText={(this.props.topLink.pcText) ? this.props.topLink.pcText + ' TOP': null}
                              mbText={(this.props.topLink.mbText) ? this.props.topLink.mbText + ' TOP': null}
                              href={this.props.topLink.href}
                              external={this.props.topLink.external}
                              current={current}
                              current2={current}
                            />
                          </li>
                        )
                      } else {
                        return (
                          <li ref={'itemTop'} data-current="">
                            <SubNavigationLink
                              pageName={(this.props.topLink.pageName) ? this.props.topLink.pageName + ' TOP': null}
                              pcText={(this.props.topLink.pcText) ? this.props.topLink.pcText + ' TOP': null}
                              mbText={(this.props.topLink.mbText) ? this.props.topLink.mbText + ' TOP': null}
                              href={this.props.topLink.href}
                              external={this.props.topLink.external}
                              current={this.props.topLink.current}
                              current2={this.props.topLink.current}
                            />
                          </li>
                        )
                      }
                    } else {
                      return null
                    }
                  })()}
                  {this.props.links.map((link, index) => {
                    // 第2階層リンク、第3階層リンク
                    this.items.push('item' + index);
                    return (
                      <li key={index} ref={'item' + index} data-current={(link.current) ? 'current': ''}>
                        <SubNavigationLink
                          pageName={link.pageName}
                          pcText={link.pcText}
                          mbText={link.mbText}
                          href={link.href}
                          external={link.external}
                          current={link.current}
                          current2={this.props.end}
                        />
                      </li>
                    )
                  })}
                </ul>
              </NavigationContainer>
            )
          } else {
            return null;
          }
        })()}
      </div>
    )
  }

  //
  getItemPositions = () => {
    //console.log(this.items);
    let arr = [0];
    let total = 0;
    let i, max;
    for (i = 0, max = this.items.length; i < max; i = i + 1) {
      const width = this.refs[this.items[i]].clientWidth;
      total = total + width;
      arr.push(total);
    }
    return arr;
  };

  //
  getCurrentItemPosition = () => {
    let total = 0;
    let i, max;
    for (i = 0, max = this.items.length; i < max; i = i + 1) {
      const width = this.refs[this.items[i]].clientWidth;
      if (this.refs[this.items[i]].dataset.current === 'current') {
        return total + (width / 2)
      }
      total = total + width;
    }
    return 0;
  };

}

/**
 * SubNavigationLink
 */
const SubNavigationLink = ({
                             pageName,
                             pcText,
                             mbText,
                             href,
                             external,
                             current,
                             current2,
                           }) => {
  const getPcText = () => {
    if (pcText !== null) {
      return pcText;
    } else {
      return pageName;
    }
  };
  const getMbText = () => {
    if (mbText !== null) {
      return mbText;
    } else if (pcText !== null) {
      return pcText;
    } else {
      return pageName;
    }
  };
  return (
    <a
      className={'SubNavigation__link' + ((current === true) ? ' current': '') + ((current2 === true) ? ' current2': '')}
      href={href} target={(external === true) ? '_blank': ''}>
      <span className="SubNavigation__link-container">
        <span className="SubNavigation__link-pc">
          <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getPcText())}}/>
        </span>
        <span className="SubNavigation__link-mb">
          <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getMbText())}}/>
        </span>
        <span className="SubNavigation__link-border"/>
      </span>
    </a>
  )
};



// WEBPACK FOOTER //
// ./src/containers/sub-navigation/pc.jsx